
import UseAnimations from "react-useanimations";
import loading from 'react-useanimations/lib/loading';

const Load = ({ align_center })=> {
    return (
        <>
            {align_center ?
                <div style={{display: "flex", alignContent: "center", justifyContent: "center", marginTop: "50px"}}>
                    <UseAnimations strokeColor={'#fff'} animation={loading} size={50} />
                </div>
                :
                <UseAnimations strokeColor={'#fff'} animation={loading} size={50} />
            }
        </>
    )
}

export default Load